import { MiniSearchSkeleton, PopularItems } from "@repo/components";
import { useTranslations } from "next-intl";
const PopularSearch = ({
  popuparSearch,
  isPending,
  setShowPopOver,
  onClick
}) => {
  const t = useTranslations("Common");
  return <div className="bg-miniSearch-bg top-10 z-50 min-h-64 w-full rounded-b-sm px-3 py-4" data-sentry-component="PopularSearch" data-sentry-source-file="PopularSearch.jsx">
      {isPending ? <MiniSearchSkeleton /> : <>
          <h4 className="font-heading text-miniSearch-heading rtl:font-arabic flex items-center pb-1 text-xl font-medium">
            {t("Popular_Search")}
          </h4>
          {popuparSearch?.sections?.map((section, index) => <div key={`${section?.type}-${index}`}>
              {section?.type === "popularProducts" && <h5 className="font-heading rtl:font-arabic text-miniSearch-heading py-3 text-lg font-medium">
                  {t("Products")}
                </h5>}
              {section?.type === "popularCategories" && <h5 className="font-heading rtl:font-arabic text-miniSearch-heading py-3 text-lg font-medium">
                  {t("Categories")}
                </h5>}
              <PopularItems items={section?.items} setShowPopOver={setShowPopOver} onClick={onClick} />
            </div>)}
        </>}
    </div>;
};
export default PopularSearch;